import React from 'react';

const MainContext = React.createContext();

// Usage:
//   Class: static contextType = MainContext; then use this.context
//   Function: const ctx = useContext(MainContext);

export const MainProvider = MainContext.Provider;
export const MainConsumer = MainContext.Consumer;

export default MainContext;